import { memo, useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../core/auth-provider";
import { useMerchantInfo } from "../../hooks/use-merchant-info";
import { LandingSkeleton } from "../../steps/landing-skeleton";
import { LoginModal } from "../ui/login-modal";
import * as shellStyles from "./onboarding-shell.module.css";

const LOAD_TIMEOUT_MS = 10_000;

export const AuthGuard = memo(function AuthGuard() {
  const auth = useAuth();
  const { merchantInfo, loading, error } = useMerchantInfo();
  const [timedOut, setTimedOut] = useState(false);

  useEffect(() => {
    if (!loading) {
      return;
    }
    setTimedOut(false);
    const timer = setTimeout(() => setTimedOut(true), LOAD_TIMEOUT_MS);
    return () => clearTimeout(timer);
  }, [loading]);

  if (!auth) {
    return (
      <div className={shellStyles.shell}>
        <LandingSkeleton />
        <LoginModal />
      </div>
    );
  }

  if (loading) {
    return (
      <div className={shellStyles.shell}>
        <LandingSkeleton />
        {timedOut && <LoginModal />}
      </div>
    );
  }

  if (error || !merchantInfo) {
    return (
      <div className={shellStyles.shell}>
        <LandingSkeleton />
        <LoginModal />
      </div>
    );
  }

  return <Outlet />;
});
